import {CrudModel} from '@ngx-ivengi/crud';
import {IFormSelectOption} from '@brands-compart/form-wizard';

export class Contact extends CrudModel implements IFormSelectOption {

  public userId: string;
  public referenceId: string; // Only used when retrieving contact links instead of contacts
  public referenceName: string; // Only used when retrieving contact links instead of contacts
  public contactId: string; // Only used when retrieving contact links instead of contacts
  public enabled: boolean;
  public firstName: string;
  public lastName: string;
  public name: string;
  public email: string;
  public permission: string = 'ELEVATED';
  public type: string;

  public setUserId(userId: string): Contact {
    const allowedTypes = ['string', 'number'];
    if(allowedTypes.indexOf(typeof userId) !== -1) {
      this.userId = userId;
    }
    return this;
  }

  public setReferenceId(referenceId: string): Contact {
    if(typeof referenceId === 'string') {
      this.referenceId = referenceId;
    }
    return this;
  }

  public setReferenceName(referenceName: string): Contact {
    if(typeof referenceName === 'string') {
      this.referenceName = referenceName;
    }
    return this;
  }

  public setContactId(contactId: string): Contact {
    if(typeof contactId === 'string') {
      this.contactId = contactId;
    }
    return this;
  }

  public setEnabled(enabled: boolean): Contact {
    if (typeof enabled === 'boolean') {
      this.enabled = enabled;
    }
    return this;
  }

  public setLastName(lastName: string): Contact {
    if(typeof lastName === 'string') {
      this.lastName = lastName;
    }
    return this;
  }

  public setFirstName(firstName: string): Contact {
    if(typeof firstName === 'string') {
      this.firstName = firstName;
    }
    return this;
  }

  public setName(name: string): Contact {
    if(typeof name === 'string') {
      this.name = name;
    }
    return this;
  }

  public setEmail(email: string): Contact {
    if(typeof email === 'string') {
      this.email = email;
    }
    return this;
  }

  public setPermission(permission: string): Contact {
    if(typeof permission === 'string') {
      this.permission = permission;
    }
    return this;
  }

  public setType(type: string): Contact {
    if(typeof type === 'string') {
      this.type = type;
    }
    return this;
  }

  public fromResponse(response: any): void {
    // First set id. Whether it is a entity or link id.
    this
      .setId(response.id);

    if(response.contactId) {
      this.setContactId(response.contactId);
    }

    // Set optional properties
    if(response.referenceId) {
      this
        .setReferenceId(response.referenceId)
        .setContactId(response.id);
    }

    if(response.type) {
      const type = response.type.toLowerCase();
      if(response.contact && response.contact[type] && response.contact[type].name) {
        this.setReferenceName(response.contact[type].name);
      }
    }

    // Check if the response is a entity or a link and use the right one
    if(typeof response.contact === 'object') {
      response = response.contact;
    }

    if(typeof response.user !== 'undefined') {
      this
        .setUserId(response.user.id)
        .setEnabled(response.user.enabled)
        .setFirstName(response.user.firstName)
        .setLastName(response.user.lastName)
        .setName(`${response.user.firstName} ${response.user.lastName}`)
        .setEmail(response.user.email);
    }

    if(typeof response.permission !== 'undefined') {
      this.setPermission(response.permission);
    }

    if(response.referenceId) {
      this.setReferenceId(response.referenceId);
    }
  }

  toKeyValueOption(): {label: string; value: any, disabled?: boolean} {

    let label = '';
    if(this.referenceName && this.referenceName.length) {
      label += this.referenceName + ' | ';
    }
    label += `${this.name}${(!this.enabled) ? ' (uitgeschakeld)' : ''}`;

    return {
      label: label,
      value: this.contactId
    };
  }
}





// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/contact/contact.model.ts